'use client';

import { Spinner, spinnerTag } from '@ni/nimble-components/dist/esm/spinner';
import { wrap } from '../utilities/react-wrapper';

export { spinnerTag };
export { type Spinner };
export const NimbleSpinner = wrap(Spinner);
